import { DrEntity } from "./dr-entity";
import { AnalyticNodeMode, MonitorStatus } from "./enums";
import { ActionType, ObjectActionListType, Permissions } from '../models/permission';

export class RealmNode extends DrEntity {
    aeComponentMonitorStatus: string;
    analyticNodeMode: AnalyticNodeMode;
    connectorMonitorStatus: string;
    contact: string;
    description: string;
    ipAddress: string;
    location: string;
    monitorStatus: MonitorStatus;
    name: string;
    nodeType: string;
    numberCores: number;
    numberThreadsExecuting: number;
    storageExport: string;
    storageMonitorStatus: string;
    storageName: string;
    windows: boolean;

    monitorStatusUI: string;
    iconClass: string;
    iconColor: string;
    buttonIconClass: string = 'fa-trash';
    buttonIconColor: string = 'color-red-05';
    isButtonVisible: boolean = true;

    hasRealmNodesAddEditPermissions: boolean;

    constructor(value?: Partial<RealmNode>) {
        super(value);
        if (value) {
            if (value.monitorStatus === MonitorStatus.AVAILABLE) {
                this.iconClass = 'fa-check'; this.iconColor = 'color-green-04';
                this.monitorStatusUI = 'Available';
            } else {
                this.iconClass = 'fa-exclamation-triangle'; this.iconColor = 'color-tan-07';
                this.monitorStatusUI = 'Warning';
            }
            this.hasRealmNodesAddEditPermissions = Permissions.checkUserPermission(ObjectActionListType.REALM_NODES, ActionType.EDIT);
            Object.assign(this, value);
        }
    }
}